import { AudioLines, Mic, MicOff } from "lucide-react";
import type { VoiceParticipant } from "@ma-soi/game-core";

export function VoicePlayerBadge({
  participant,
  speakingOnly = false,
}: {
  participant?: VoiceParticipant;
  speakingOnly?: boolean;
}) {
  if (!participant?.connected) return null;
  if (speakingOnly && !participant.isSpeaking) return null;
  const muted = participant.mutedBySelf || participant.mutedByHost || !participant.audioPermissionGranted;
  return (
    <span
      className={`voice-player-badge voice-${participant.channel} ${participant.isSpeaking ? "speaking" : ""} ${speakingOnly ? "inline-wave" : ""}`}
      title={muted ? "Bạn đang im lặng" : participant.isSpeaking ? "Đang thì thầm" : "Đang nghe"}
    >
      {participant.isSpeaking ? <AudioLines className="size-3" /> : muted ? <MicOff className="size-3" /> : <Mic className="size-3" />}
    </span>
  );
}
